<template>
	<div class="content">
		<h3>产品设置</h3>
		<div class="item">
			<div class="btn">
				<el-button icon="el-icon-plus" type="primary" @click="AddProduct">添加</el-button>
				<el-button icon="el-icon-search" type="primary"  @click="SelProduct">查询</el-button>
				<el-button type="primary">导出</el-button>
			</div>
			<el-form ref="selectproductform" :inline="true" :model="selectproductform" label-width="80px">
				<el-form-item label="产品名称">
					<el-input v-model="selectproductform.Productname" clearable></el-input>
				</el-form-item>
				<el-form-item label="产品编号">
					<el-input v-model="selectproductform.Productcode" clearable></el-input>
				</el-form-item>
				<el-form-item label="包装比例">
					<el-select v-model="selectproductform.Specid" clearable placeholder="请选择">
						<el-option
						v-for="item in pack"
						:key="item.DataId"
						:label="item.Scale"
						:value="item.Scale">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="selectproductform.IsEnable" clearable placeholder="请选择">
						<el-option
						v-for="item in state"
						:key="item.value"
						:label="item.lable"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column align="center" prop="Productcode" label="产品编号"></el-table-column>
				<el-table-column align="center" prop="Productname" label="产品名称"></el-table-column>
				<el-table-column align="center" prop="Specid" label="包装规格"></el-table-column>
				<el-table-column align="center" prop="IsEnable" label="状态"></el-table-column>
				<el-table-column align="center" label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="EditProduct(scope)">修改</el-button>
						<el-button type="text" @click="delProduct(scope)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog :title="dialogtype==1 ? '添加产品':'编辑产品'" :visible.sync="dialogVisible" width="740px">
      		<el-form ref="productform" inline style="width:auto" :model="productform" :rules="rules" label-width="100px">
				<el-form-item label="产品编号" prop="Productcode">
                    <el-input v-model="productform.Productcode"></el-input>
                </el-form-item>
				<el-form-item label="产品名称" prop="Productname">
					<el-input v-model="productform.Productname"></el-input>
				</el-form-item>
				<el-form-item label="产品类型" >
					<el-input ></el-input>
				</el-form-item>
				<el-form-item label="商品条码" prop="eancode">
					<el-input v-model="productform.eancode"></el-input>
				</el-form-item>
				<el-form-item label="查询结果"  style="width: 642px;">
					<el-input  style="width: 533px;"></el-input>
				</el-form-item>
				<el-form-item label="产品简介" prop="shortname" style="width: 642px;">
					<el-input type="textarea" v-model="productform.shortname" style="width: 533px;"></el-input>
				</el-form-item>
				<el-form-item label="产品图片" prop="SeqNo" style="width: 642px;">
					<el-upload
						action="#"
						list-type="picture-card"
						:auto-upload="false">
							<i slot="default" class="el-icon-plus"></i>
							<div slot="file" slot-scope="{file}">
							<img
								class="el-upload-list__item-thumbnail"
								:src="file.url" alt=""
							>
							<span class="el-upload-list__item-actions">
								<span
								class="el-upload-list__item-preview"
								@click="handlePictureCardPreview(file)"
								>
								<i class="el-icon-zoom-in"></i>
								</span>
								<span
								v-if="!Imgdisabled"
								class="el-upload-list__item-delete"
								@click="handleDownload(file)"
								>
								<i class="el-icon-download"></i>
								</span>
								<span
								v-if="!Imgdisabled"
								class="el-upload-list__item-delete"
								@click="handleRemove(file)"
								>
								<i class="el-icon-delete"></i>
								</span>
							</span>
							</div>
					</el-upload>
					<el-dialog :visible.sync="ImgdialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>
				<el-form-item label="扩展属性"  style="width: 642px;">
					<span style="width: 543px;display: block;">
						* 如果添加购买地址请将属性名称设为 地址名称+"_buy_site" 格式，如天猫购买地址属性名称应为："天猫_buy_site"</span>
					<el-input  style="width: 533px;"></el-input>
				</el-form-item>
				<el-form-item label="包装信息" prop="norms">
					<el-select v-model="productform.norms" clearable placeholder="请选择">
						<el-option
						v-for="item in pack"
						:key="item.DataId"
						:label="item.Scale"
						:value="item.Scale">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态" prop="IsEnable">
					<el-radio v-model="productform.IsEnable" :label="1">启用</el-radio>
  					<el-radio v-model="productform.IsEnable" :label="0">禁用</el-radio>
				</el-form-item>
			</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="restForm" type="warning">重 置</el-button>
        		<el-button type="primary" @click="SetProduct">确 定</el-button>
      		</span>
    	</el-dialog>
		</div>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			selectproductform: {
				Productname: '',
				Productcode: '',
				Specid: '',
				IsEnable:'',
			},
			productform:{
				Productcode: '',
				Productname: '',
				shortname:'',
				eancode:'',
				norms:'',
				Specid: 0,
				IsEnable:1,
				DataId:0,
				cid:''
			},
			rules: {
        		Productcode:[
          			{ required: true, validator: validateNumber, message: '请输入产品编码号，数字类型', trigger: 'change' }
        		],
        		Productname:[
          			{ required: true,  message: '请输入一个产品名称', trigger: 'blur' }
        		]
			},
			pack:[],
			state:[{
				value:0,
				lable:"禁用"
			},{
				value:1,
				lable:"启用"
			}],
			form: {},
			tableData: [],
			dialogVisible:false,
			dialogtype:0,

			dialogImageUrl: '',
			ImgdialogVisible: false,
			Imgdisabled: false
		}
	},
	mounted : function(){
		this.selPack();	
	},
	methods: {
		AddProduct(){
			this.dialogVisible=true;
			this.dialogtype=1;
		},
		EditProduct(scope){
			this.editVisible=true
			this.dialogVisible=true;
			this.dialogtype=2;
			this.$nextTick(() => {
				this.productform.Productcode=scope.row.Productcode;
				this.productform.Productname=scope.row.Productname;
				this.productform.shortname=scope.row.Shortname;
				this.productform.eancode=scope.row.Eancode;
				this.productform.norms=scope.row.Norms;
				this.productform.IsEnable=scope.row.IsEnable;
				this.productform.DataId=scope.row.DataId;
			})
		},
		delProduct(scope){
			this.$axios({
        				method: 'post',
        				url:'/FW/Product.ashx',
        			params: {
          				action:"delete",
          				product:scope.row
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelProduct()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
		},
		SetProduct(){
			this.$refs['productform'].validate((isValidate)=>{
				if(isValidate){
					var user = JSON.parse(sessionStorage.getItem('user'));
					this.productform.cid=user.QyNum
					if(this.dialogtype==1){
						//添加工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Product.ashx',
        			params: {
          				action:"add",
          				product:this.productform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelProduct()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}else if(this.dialogtype==2){
						//修改工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Product.ashx',
        			params: {
          				action:"edit",
          				product:this.productform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelProduct()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}
				}else{
					isValidate
				}
			})
		},
		selPack(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询包装比例
			this.$axios({
        		method: 'post',
        		url:'/FW/Package.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.pack=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		},
		SelProduct(){
			//查询产品
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
        		method: 'post',
        		url:'/FW/Product.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					Productname: this.selectproductform.Productname,
					Productcode: this.selectproductform.Productcode,
					Specid: this.selectproductform.Specid,
					IsEnable:this.selectproductform.IsEnable,
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.tableData=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		},
		handleRemove(file) {
        	console.log(file);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.ImgdialogVisible = true;
		},
		handleDownload(file) {
			console.log(file);
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 80px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/settingProduct.vue